// extracted by mini-css-extract-plugin
export default {"container":"_2U0RNEUUZ6PwRxrLoHD8eF","registerHeader":"_1LDtr7IqVne1YilynB3-X7","creabotsLabel":"_2HH_-RY192aff_A63iFgup","registerLaterBtn":"quf1UTKTri3df3SSrtnGn"};